// src/features/business-functions/components/workspace-detail/WorkspaceTabBarSkeleton.jsx
import React from 'react';
import { Box, Skeleton } from '@mui/material';

/**
 * Reserves tab-bar height while workspace forms are loading to prevent layout shift.
 */
export default function WorkspaceTabBarSkeleton({ styles }) {
  return (
    <Box sx={styles.tabBarRoot} aria-hidden="true">
      <Box sx={styles.tabBarSkeletonRow}>
        <Skeleton variant="text" width={180} height={28} sx={{ transform: 'none' }} />
        <Skeleton variant="text" width={120} height={28} sx={{ transform: 'none', opacity: 0.5 }} />
      </Box>
    </Box>
  );
}
